import script from "./file-preview-modal.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20IFilePreview"
export * from "./file-preview-modal.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20IFilePreview"

import "./file-preview-modal.vue?vue&type=style&index=0&id=417de253&lang=scss"

const __exports__ = script;

export default __exports__